var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"main-content"},[_c('div',{staticClass:"bg-shapes-container"},[_c('div',{staticClass:"bg-shape bg-shape-1"}),_c('div',{staticClass:"bg-shape bg-shape-2"}),_c('div',{staticClass:"bg-shape bg-shape-3"})]),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }